import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../services/supabase';
import { completeGoogleSignIn } from '../lib/googleSignIn';

/**
 * Where Google sends the user back after the HOWIE-branded consent screen
 * (/auth/google/callback). Finishes the sign-in with Supabase and continues to
 * the page the login started for. Visuals are Ethos tokens only.
 */
export default function GoogleCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    completeGoogleSignIn({
      hash: window.location.hash,
      signInWithIdToken: (credentials) => supabase.auth.signInWithIdToken(credentials),
    })
      .then((next) => {
        if (!cancelled) navigate(next, { replace: true });
      })
      .catch((caught: unknown) => {
        if (!cancelled) setError(caught instanceof Error ? caught.message : 'Google sign-in failed.');
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <main className="flex min-h-svh items-center justify-center bg-how-paper-soft px-5 text-how-space-deep">
      {error ? (
        <div className="w-full max-w-sm text-center" role="alert">
          <p className="font-body text-base">{error}</p>
          <Link
            to="/login"
            className="mt-6 inline-flex h-12 items-center justify-center rounded-xl bg-how-space-deep px-6 text-sm text-how-paper-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-how-space-deep focus-visible:ring-offset-2"
          >
            Back to sign in
          </Link>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-4">
          <div className="spinner" aria-label="Signing you in" />
          <p className="text-sm text-how-text-secondary">Signing you in…</p>
        </div>
      )}
    </main>
  );
}
